import React, { useState } from "react";
import styles from "./Home.module.scss";
import Header from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import { PageLayoutContext } from "../../contexts/PageLayoutContext";

const Home = ({ page, hideHeader = false }) => {
  const [pageLayout, setPageLayout] = useState({ flushBottom: false });

  return (
    <div className={styles.page_outer}>
      <div className={styles.headers_container}>
        {!hideHeader && <Header />}
        <Sidebar />
      </div>

      <PageLayoutContext.Provider value={setPageLayout}>
        <div
          className={`${styles.page}${pageLayout.flushBottom ? ` ${styles.page_flush_bottom}` : ""}`}
        >
          {page}
        </div>
      </PageLayoutContext.Provider>
    </div>
  );
};

export default Home;
